import { Sortable } from './sortable';

export class MixDesignIngredientTypes {
  public static CEMENT_POWDER = 532;
  public static WATER = 533;
  public static COARSE_AGGREGATE = 534;
  public static FINE_AGGREGATE = 535;
  public static ADMIXTURE = 538;
  public static SCM = 539;
  public static sortOrder = [
    MixDesignIngredientTypes.CEMENT_POWDER,
    MixDesignIngredientTypes.SCM,
    MixDesignIngredientTypes.WATER,
    MixDesignIngredientTypes.COARSE_AGGREGATE,
    MixDesignIngredientTypes.FINE_AGGREGATE,
    MixDesignIngredientTypes.ADMIXTURE,
  ];
}

export interface MixDesignIngredientType extends Sortable {
  id: number;
  name: string;
  validUnitIds: number[];
  defaultUnitSettingId?: number;
}
